<div [hidden]="!menuEnabled">
  <div class="row mt-3">
    <div class="col-md-4 col-6 mx-auto">
      <img src="../../assets/images/คำนวณเงินคุ้มครอง-2_{{lang}}.jpg" class="w-100">
    </div>
  </div>
  <div class="row">
    <div class="col-md-8 col-12 mx-auto img-step">
      <img src="../../assets/images/simulate{{step}}_{{lang}}.jpg" class="w-100">
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-10 col-12 mx-auto w-100" style="height: 5px; background-color: var(--cust-blue);"></div>
  </div>
  <div class="row mb-3">
    <div class="col-md-10 col-12 mx-auto sim-form ">
      <div class="row">
        <div class="col-12 text-center">
          <label class="sim-header text-cust-blue" *ngIf="step == 1" translate>SimulateStep1Header</label>
          <label class="sim-header text-cust-blue" *ngIf="step == 2" translate>SimulateStep2Header</label>
          <label class="sim-header text-cust-blue" *ngIf="step == 3" translate>SimulateStep3Header</label>
        </div>
      </div>

      <div class="row">
        <div class="col-12 table-responsive lg-screen" *ngIf="step == 1 && !isSmallScreen">
          <table class="table table-hover" id="tbSetp1">
            <thead>
              <tr>
                <th colspan="2">
                </th>
                <th translate>Financial Institution</th>
                <th translate>DepositType</th>
                <th translate>DepositAmount</th>
                <th translate>Joint Account</th>
                <th translate>Portion</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let a of depositAcc; let i = index">
                <td>
                  <button type="button" class="btn btn-link text-danger" (click)="deleteAcc(i)">
                    <span class="fa fa-trash"></span>
                  </button>
                </td>
                <td>
                  <label translate>Simulate Account No.</label> {{i + 1}}
                </td>
                <td>
                  <select [className]="a.bankId == '' ? 'form-control invalid' : 'form-control'" [(ngModel)]="a.bankId"
                    (change)="onBankDepositChange(i)">
                    <option value="" translate>Select</option>
                    <option *ngFor="let b of bankList" [value]="b.dpa_bankid">
                      {{b.dpa_name}}
                    </option>
                  </select>
                </td>
                <td>
                  <select class="form-control" [(ngModel)]="a.bankType">
                    <option value="" translate>Select</option>
                    <option value="A" translate>Deposit</option>
                    <option value="B" translate>Fixed</option>
                    <option value="C" translate>CertificateOfDeposit</option>
                  </select>
                </td>
                <td>
                  <div class="input-group">
                    <input type="text" [className]="a.amount == null ? 'form-control invalid' : 'form-control'"
                      (keypress)="numberAndDotOnly($event)" [(ngModel)]="a.amount" (focusout)="step1FocusOut(i)"
                      (change)="calStep1(i)" step=".01">
                    <div class="input-group-append">
                      <span class="input-group-text" translate>baht</span>
                    </div>
                  </div>
                </td>
                <td>
                  <input type="checkbox" class="form-control" [(ngModel)]="a.shared" (change)="calStep1(i)">
                </td>
                <td>
                  <div class="input-group">
                    <input type="number" min="0" step="0.01" max="99.99" [disabled]="!a.shared"
                      [className]="a.shared && (a.percent == null || a.percent <= 0) ? 'form-control invalid' : 'form-control'"
                      (keypress)="numberAndDotOnly($event)" [(ngModel)]="a.percent" (change)="calStep1(i)">
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <button type="button" class="btn btn-outline-success" (click)="addAcc()">
                    <span class="fa fa-plus-circle"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" *ngIf="step == 1 && isSmallScreen">
          <div class="row">
            <div class="col-12">
              <button type="button" class="btn btn-outline-success" (click)="addAcc()">
                <span class="fa fa-plus-circle"></span>
              </button>
              <button type="button" class="btn btn-outline-danger" (click)="deleteAcc()">
                <span class="fa fa-minus-circle"></span>
              </button>
            </div>
          </div>
          <div class="row" *ngFor="let a of depositAcc; let i = index">
            <div class="col-4 align-self-center">
              <label>
                <input type="checkbox" class="form-control " [(ngModel)]="a.selected">
                <label translate>Item</label> {{i + 1}}
              </label>
            </div>
            <div class="col-8">
              <div class="form-group">
                <label translate>Financial Institution</label>
                <select [className]="a.bankId == '' ? 'form-control invalid' : 'form-control'" [(ngModel)]="a.bankId"
                  (change)="onBankDepositChange(i)">
                  <option value="" translate>Select</option>
                  <option *ngFor="let b of bankList" [value]="b.dpa_bankid">
                    {{b.dpa_name}}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label translate>DepositType</label>
                <select class="form-control" [(ngModel)]="a.bankType">
                  <option value="" translate>Select</option>
                  <option value="A" translate>Deposit</option>
                  <option value="B" translate>Fixed</option>
                  <option value="C" translate>CertificateOfDeposit</option>
                </select>
              </div>
              <div class="form-group">
                <label translate>DepositAmount</label>
                <div class="input-group">
                  <input type="text" min="0" [className]="a.amount == null ? 'form-control invalid' : 'form-control'"
                    (keypress)="numberAndDotOnly($event)" [(ngModel)]="a.amount" (focusout)="step1FocusOut(i)"
                    (change)="calStep1(i)" step=".01">
                  <div class="input-group-append">
                    <span class="input-group-text" translate>baht</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label translate>Joint Account</label>
                <input type="checkbox" class="form-control" [(ngModel)]="a.shared" (change)="calStep1(i)">
              </div>
              <div class="form-group">
                <label translate>Portion</label>
                <div class="input-group">
                  <input type="number" min="0" step="0.01" max="99.99" [disabled]="!a.shared"
                    [className]="a.shared && (a.percent == null || a.percent <= 0) ? 'form-control invalid' : 'form-control'"
                    (keypress)="numberAndDotOnly($event)" [(ngModel)]="a.percent" (change)="calStep1(i)">
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="col-12 table-responsive" *ngIf="step == 2 && !isSmallScreen">
          <table class="table table-hover" id="tbSetp2">
            <thead>
              <tr>
                <th colspan="2"></th>
                <th translate>Financial Institution </th>
                <th translate>Debt Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let a of debtAcc; let i = index">
                <td>
                  <button type="button" class="btn btn-link text-danger" (click)="deleteDebt(i)">
                    <span class="fa fa-trash"></span>
                  </button>
                </td>
                <td>
                  <label translate>Item</label> {{i + 1}}
                </td>
                <td>
                  <select [className]="a.bankId == '' ? 'form-control invalid' : 'form-control'" [(ngModel)]="a.bankId"
                    (change)="onBankDebtChange(i)">
                    <option value="" translate>Select</option>
                    <option *ngFor="let b of bankList" [value]="b.dpa_bankid">
                      {{b.dpa_name}}
                    </option>
                  </select>
                </td>
                <td>
                  <div class="input-group">
                    <input type="text" min="0" [className]="a.total == null ? 'form-control invalid' : 'form-control'"
                      (keypress)="numberAndDotOnly($event)" [(ngModel)]="a.total" (focusout)="step2FocusOut(i)"
                      (change)="calStep2(i)" step=".01">
                    <div class="input-group-append">
                      <span class="input-group-text" translate>baht</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <button type="button" class="btn btn-outline-success" (click)="addDebt()">
                    <span class="fa fa-plus-circle"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" *ngIf="step == 2 && isSmallScreen">
          <div class="row">
            <div class="col-12">
              <button type="button" class="btn btn-outline-success" (click)="addDebt()">
                <span class="fa fa-plus-circle"></span>
              </button>
              <button type="button" class="btn btn-outline-danger" (click)="deleteDebt()">
                <span class="fa fa-minus-circle"></span>
              </button>
            </div>
          </div>
          <div class="row" *ngFor="let a of debtAcc; let i = index">
            <div class="col-4 align-self-center">
              <label>
                <input type="checkbox" class="form-control" [(ngModel)]="a.selected">
                <label translate>Item</label> {{i + 1}}
              </label>
            </div>
            <div class="col-8">
              <div class="form-group">
                <label translate>Financial Institution</label>
                <select [className]="a.bankId == '' ? 'form-control invalid' : 'form-control'" [(ngModel)]="a.bankId"
                  (change)="onBankDebtChange(i)">
                  <option value="" translate>Select</option>
                  <option *ngFor="let b of bankList" [value]="b.dpa_bankid">
                    {{b.dpa_name}}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label translate>Debt Amount</label>
                <div class="input-group">
                  <input type="text" min="0" [className]="a.total == null ? 'form-control invalid' : 'form-control'"
                    (keypress)="numberAndDotOnly($event)" [(ngModel)]="a.total" (focusout)="step2FocusOut(i)"
                    (change)="calStep2(i)" step=".01">
                  <div class="input-group-append">
                    <span class="input-group-text" translate>baht</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12" *ngIf="step == 3">
          <div class="col-10 mx-auto border border-default rounded" *ngFor="let r of refundList">
            <div class="row p-2 mb-2">
              <div class="col-6">
                <label>{{r.bankName}}</label>
              </div>
              <div class="col-6 text-right">
                <label>{{r.deposit | currency:'THB':''}}</label><label translate>baht</label>
              </div>
            </div>
          </div>

          <div class="col-10 mx-auto">
            <label class="remark1">{{remark1}}</label>
            <br>
            <label class="remark2">{{remark2}}</label>
          </div>
        </div>
      </div>

      <div class="row mt-3 sim-form-line"></div>
      <div class="row pl-3 pr-3">
        <label class="text-danger" translate>
          SimulateRemark
        </label>
      </div>
      <div class="row pl-3 pr-3 mt-3" *ngIf="debtNotMatch">
        <label class="text-danger" translate>
          SimulateRemark2
        </label>
      </div>

      <div class="row mt-3">
        <div class="col-12 text-center">
          <label class="sub-header" *ngIf="step == 1" translate>TotalDepositAmount</label>
          <label class="sub-header" *ngIf="step == 2" translate>Total Debt</label>
          <label class="sub-header" *ngIf="step == 3" translate>Reimbursement Amount</label>
        </div>
      </div>

      <div class="row mt-3" *ngIf="step == 1">
        <div class="col-10 mx-auto border border-default rounded" *ngFor="let a of totalDepositAcc">
          <div class="row p-2 mb-2">
            <div class="col-6">
              <label>{{a.bankName}}</label>
            </div>
            <div class="col-6 text-right">
              <label>{{a.total | currency:'THB':''}}</label><label translate>baht</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3" *ngIf="step == 2">
        <div class="col-10 mx-auto border border-default rounded" *ngFor="let d of totalDebtAcc">
          <div class="row p-2 mb-2">
            <div class="col-6">
              <label>{{d.bankName}}</label>
            </div>
            <div class="col-6 text-right">
              <label>{{d.total | currency:'THB':''}}</label><label translate>baht</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3" *ngIf="step == 3">
        <div class="col-10 mx-auto border border-default rounded" *ngFor="let r of refundList">
          <div class="row p-2 mb-2">
            <div class="col-6">
              <label>{{r.bankName}}</label>
            </div>
            <div class="col-6 text-right">
              <label>{{r.total | currency:'THB':''}}</label><label translate>baht</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-1 mb-1">
        <div class="col-12 text-center">
          <button class="btn btn-default m-2" (click)="step = 1" *ngIf="step > 1" translate>backToFirstStep</button>
          <button class="btn btn-default m-2" (click)="prevStep()" *ngIf="step > 1" translate>Back</button>
          <button class="btn btn-default m-2" (click)="nextStep()" *ngIf="step < 2" translate>Next</button>
          <button class="btn btn-default m-2" (click)="nextStep()" *ngIf="step == maxStep - 1"
            translate>Calculate</button>
          <button class="btn btn-default m-2" (click)="goToIndex()" *ngIf="step == maxStep" translate>Home</button>
        </div>
      </div>
    </div>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/simulator/simulator.component.html